module.exports = __webpack_public_path__ + "img/inBan_smal_img05.de2ca01c.png";